import {ChangeDetectorRef, Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalComponent} from '../../../shared/modal/modal.component';
import {Router} from '@angular/router';
import {UserService} from '../../../shared/services/user.service';
import { FEATURED_GAMES, Game } from '../../../shared/constants/games.constant';

@Component({
  selector: 'app-featured-games',
  templateUrl: './featured-games.component.html',
  styleUrls: ['./featured-games.component.scss'],
  imports: [CommonModule, ModalComponent]
})
export class FeaturedGamesComponent {
  games: Game[] = FEATURED_GAMES;
  isModalOpen = false;
  isAddPointsModalOpen = false;
  selectedGame!: Game;
  modalText = '';

  constructor(private router: Router, private userService: UserService, private cdr: ChangeDetectorRef) {}

  openModal(game: Game) {
    this.selectedGame = game;

    this.userService.canAffordPoints(this.selectedGame.points).subscribe({
      next: (res) => {
        if (res.canAfford) {
          this.modalText = `Starting this game will cost you ${game.points} points. Do you want to continue?`;
          this.isModalOpen = true;
          this.isAddPointsModalOpen = false;
          this.cdr.detectChanges();
        } else {
          this.isModalOpen = false;
          this.isAddPointsModalOpen = true;
          this.cdr.detectChanges();
        }
      },
      error: (err) => {
        console.error('Ошибка при проверке баланса:', err);
      }
    });
  }

  closeModal() {
    this.isModalOpen = false;
    this.isAddPointsModalOpen = false;
  }

  goToShop() {
    this.router.navigate(['/shop']);
  }

  startGame() {
    this.router.navigate(['/game'], {
      queryParams: {
        name: this.selectedGame.name,
        image: this.selectedGame.image,
        path: this.selectedGame.folder,
        points: this.selectedGame.points
      }
    });
    this.isModalOpen = false;
  }
}
